<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  import { mapActions, mapMutations } from 'vuex';

  export default {
    name: 'App',
    methods: {
      ...mapActions(['ping']),
      ...mapMutations(['setSid', 'setRole', 'setClubId', 'setUsername']),
    },
    async created() {
      const sid = window.localStorage.getItem('sid');
      const role = window.localStorage.getItem('role');
      const roleId = window.localStorage.getItem('roleId');
      const username = window.localStorage.getItem('username');

      // Set state dependent data.
      this.setSid(sid);
      this.setRole(role);
      this.setUsername(username);
      switch (role) {
        case 'club':
          this.setClubId(roleId);
          break;
        default:
          this.$router.replace('/login');
      }

      try {
        await this.ping();
      } catch (e) {
        window.localStorage.removeItem('sid');
        window.localStorage.removeItem('role');
        window.localStorage.removeItem('roleId');
        window.localStorage.removeItem('username');
        commit('setSid', null);
        commit('setError', 'Ваша попытка входа не удалась, попробуйте еще раз.');
        this.$router.replace('/login');
        return;
      }

      // Route.
      switch (role) {
        case 'club':
          return this.$router.replace(`/club/invoice/list`);
        default:
          throw new Error(`unknown ${role} role`);
      }
    },
  }
</script>

<style>
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font-style: normal;
  vertical-align: baseline;
  outline: 0;
}
h1,
h2,
h3,
h4,
h5 {
  font-weight: normal;
}
</style>

